import {
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";
import { Root } from "@definitions";
import { VisibleGroupNode } from "src/definitions/ui-definitions";

export class VisibleGroupComponentBuilder
	implements UiComponentBuilder<Root, VisibleGroupNode>
{
	public build(
		_node: VisibleGroupNode,
		context: UiComponentBuildContext<Root>,
	) {
		return <>{context.childElements}</>;
	}
}
